import React from 'react';
import { motion } from 'framer-motion';
export function FinalCTA() {
  return <section className="bg-brand-black text-white py-20 px-4 sm:px-6 lg:px-8 text-center relative overflow-hidden" data-id="element-37">
      <div className="absolute inset-0 bg-brand-purple rounded-full blur-[150px] opacity-20 max-w-3xl mx-auto top-1/2 -translate-y-1/2" data-id="element-38"></div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-39">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-40">
          <h2 className="text-4xl sm:text-5xl font-bold mb-8" data-id="element-41">
            Start Feeling Better Today
          </h2>

          <p className="text-yellow-400 text-sm font-semibold mb-3 flex items-center gap-1.5 justify-center" data-id="element-42">
            <span data-id="element-43">⚠️</span> Limited stock available – selling fast
          </p>
          <a href="https://zenifyliving.com/cart/48194365325482:1?checkout" className="block w-full sm:w-auto text-center bg-brand-purple hover:bg-brand-purple-dark text-white font-bold text-xl py-5 px-12 rounded-full transition-all duration-300 shadow-[0_0_30px_rgba(124,58,237,0.5)] hover:shadow-[0_0_40px_rgba(124,58,237,0.7)] hover:scale-105 mb-4" data-id="element-44">
            BUY NOW — LIMITED STOCK
          </a>

          <p className="text-gray-400 text-sm mb-16" data-id="element-45">
            No risk. 30-day money-back guarantee.
          </p>
        </motion.div>
      </div>

      <footer className="relative z-10 mt-12 pt-8 border-t border-white/10 text-gray-500 text-sm flex flex-col sm:flex-row justify-between items-center max-w-7xl mx-auto" data-id="element-46">
        <div className="font-playfair font-bold text-xl text-white mb-4 sm:mb-0" data-id="element-47">
          ZENIFY LIVING
        </div>
        <p data-id="element-48">© {new Date().getFullYear()} Zenify Living. All rights reserved.</p>
      </footer>
    </section>;
}